/**
 * Format a date string according to the provided format.
 * @param {string} dateString - The date string to format.
 * @param {string} format - The format string, e.g., 'MM/DD/YYYY'.
 * @returns {string} - The formatted date string.
 */
export const formatDate = (dateString, format) => {
  const date = new Date(dateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return ''; // Return an empty string for invalid dates
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  // Replace the format placeholders with actual values
  return format
    .replace('DD', day) // Note: Use 'DD' for day
    .replace('MM', month) // Use 'MM' for month
    .replace('YYYY', year); // Use 'YYYY' for year
};

/**
 * Format a date string with error handling.
 * @param {string} dateString - The date string to format.
 * @param {string} formatStr - The format string, e.g., 'MM/DD/YYYY'.
 * @returns {string} - The formatted date string or an empty string if there's an error.
 */
export const formatDateWithFns = (dateString, formatStr) => {
  try {
    return formatDate(dateString, formatStr);
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};
